// AWS Amplify Configuration - Loaded dynamically from /config.json
let awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: 'PLACEHOLDER_USER_POOL_ID',
      userPoolClientId: 'PLACEHOLDER_CLIENT_ID',
      region: 'ap-northeast-1',
    },
  },
};

let apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

function hasPlaceholders(cfg: typeof awsconfig): boolean {
  const c = cfg.Auth.Cognito;
  return (
    !c.userPoolId ||
    !c.userPoolClientId ||
    c.userPoolId.startsWith('PLACEHOLDER') ||
    c.userPoolClientId.startsWith('PLACEHOLDER') ||
    c.region === 'placeholder'
  );
}

// Fetch runtime config from S3/CloudFront or use environment variables
export async function loadConfig() {
  try {
    // Try environment variables first (for local development)
    const envUserPoolId = process.env.REACT_APP_USER_POOL_ID;
    const envClientId = process.env.REACT_APP_USER_POOL_CLIENT_ID;
    const envApiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    if (envUserPoolId && envClientId) {
      awsconfig = {
        Auth: {
          Cognito: {
            userPoolId: envUserPoolId,
            userPoolClientId: envClientId,
            region: process.env.REACT_APP_COGNITO_REGION || 'ap-northeast-1',
          },
        },
      };
      if (envApiBaseUrl) {
        apiBaseUrl = envApiBaseUrl;
      }
      if (hasPlaceholders(awsconfig)) {
        // Environment variables supplied but still contain placeholders.
      }
      return awsconfig;
    }

    // Fallback to runtime config file
    const response = await fetch('/config.json');
    if (response.ok) {
      const config = await response.json();
      awsconfig = {
        Auth: {
          Cognito: {
            userPoolId: config.aws.cognito.userPoolId,
            userPoolClientId: config.aws.cognito.userPoolClientId,
            region: config.aws.cognito.region,
          },
        },
      };
      if (config.aws.apiBaseUrl) {
        apiBaseUrl = config.aws.apiBaseUrl;
      }
      if (hasPlaceholders(awsconfig)) {
        // /config.json loaded but contains placeholder values.
      }
    } else {
      // Failed to load /config.json, using defaults
    }
  } catch (error) {
    // Failed to load runtime config
  }
  if (hasPlaceholders(awsconfig)) {
    // Falling back to placeholder configuration.
  }
  return awsconfig;
}

export function getApiBaseUrl(): string {
  return apiBaseUrl;
}

export default awsconfig;
